import { render, staticRenderFns } from "./MerchantEditDialog.vue?vue&type=template&id=608e084b&scoped=true&"
import script from "./MerchantEditDialog.vue?vue&type=script&lang=js&"
export * from "./MerchantEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./MerchantEditDialog.vue?vue&type=style&index=0&id=608e084b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e084b",
  null
  
)

export default component.exports